import $ from 'jquery';
import _ from 'lodash';
import selector from './selector';

/**
 * Toggles the visual display of an element on the page.
 * Contains action directives for interacting with a toggler element:
 *  - toggler-open
 *  - toggler-close
 *  - toggler-toggle
 *  - toggler-select
 *
 * @param context
 */

let optionalData = {}, cardsData = {}, planData = {};

function getTextFromValue(value) {
	return parseFloat(value, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
}

function optionalNumbers() {

	const optionals = $('.checkout_optionalNumbertable');

	if (optionals.length) {
		optionals.each(function (index, el) {
			let optional = $(this);
			let optionalInput = optional.find('input');
			optionalInput.focus(function () {
				$(this).select();
			});
			let totalColumns = optional.data('didtablecolumns');

			optionalInput.keyup(function () {
				optionalData[index] = [];
				for (let i = 1; i <= totalColumns; i++) {
					// console.log('volumeX '+ i, '[data-volume-in-'+i+']',$('[data-volume-in-'+i+']').data('volumeIn-'+i));
					// console.log('volume '+ i, '[data-volume-in-'+i+']',$('[data-volume-in-'+i+']').val());
					//
					// console.log('setup cost '+ i, '[data-cost--'+i+']',$('[data-cost-'+i+']').data('cost-'+i));
					// console.log('setup  perUser? '+ i, '[data-cost-perUser-'+i+']',$('[data-cost-perUser-'+i+']').data('costPeruser-'+i));
					// console.log('mrc cost '+ i, '[data-mrc--'+i+']',$('[data-mrc-'+i+']').data('mrc-'+i));
					// console.log('mrc perUser? '+ i, '[data-mrc-perUser-'+i+']',$('[data-mrc-perUser-'+i+']').data('mrcPeruser-'+i));
					// console.log('----------------');

					let totalSetupIndex = optional.find('.totalSetup' + i);
					let monthlySetupIndex = optional.find('.monthlySetup' + i);
					let dataVolumeIn = optional.find('[data-volume-in-' + i + ']');

					let volumeX = dataVolumeIn.data('volumeIn-' + i);
					let volume = dataVolumeIn.val();

					let totalSetupData = '';
					let monthlySetupData = '';


					if (parseInt(volume) === 0) {
						totalSetupIndex.html('$0');
						monthlySetupIndex.html('$0');

						optionalData[index].push({
							totalSetup: 0,
							monthlySetup: 0
						});

						continue;
					}

					let setupCost = optional.find('[data-cost-' + i + ']').data('cost-' + i);
					let setupPerUser = optional.find('[data-cost-perUser-' + i + ']').data('costPeruser-' + i);
					let mrcCost = optional.find('[data-mrc-' + i + ']').data('mrc-' + i);
					let mrcPerUser = optional.find('[data-mrc-perUser-' + i + ']').data('mrcPeruser-' + i);

					let totalSetup = 0;
					let totalMrc = 0;

					if (setupPerUser) {
						totalSetup = volume * volumeX * setupCost;
					} else {
						totalSetup = setupCost;
					}

					if (mrcPerUser) {
						totalMrc = volume * volumeX * mrcCost;
					} else {
						totalMrc = mrcCost;
					}

					totalSetupData = getTextFromValue(totalSetup);
					monthlySetupData = getTextFromValue(totalMrc);


					totalSetupIndex.html('$' + totalSetupData);
					monthlySetupIndex.html('$' + monthlySetupData);

					optionalData[index].push({
						totalSetup: parseFloat(totalSetup),
						monthlySetup: parseFloat(totalMrc)
					});
				}

				estimateTotalCost();
			});
		});
	}
}

function extraProducts() {

	const handsets = $('.prod_card.-style-extras');

	// hide button because comparisons doesn't need the add to cart button
	// $('[data-buttonextraselect]').html('Select');

	if (handsets.length) {
		// $('[data-buttonextraselect]').hide();
		handsets.each(function (index, el) {
			let handset = $(this),
				handsetInput = handset.find('.product_qty input'),
				handsetId = handset.data('productselect'),
				handsetMonthly = parseFloat(handset.data('price')),
				handsetSetup = parseFloat(handset.data('setup-cost'));

			handsetInput.keyup(function () {
				cardsData[handsetId] = [];
				let _this = $(this);

				// if has value
				let val = parseInt(_this.val());
				if (val > 0) {
					cardsData[handsetId].push({
						totalSetup: handsetSetup * val,
						monthlySetup: handsetMonthly * val
					});
				} else {
					cardsData[handsetId].push({
						totalSetup: 0,
						monthlySetup: 0
					});
				}

				estimateTotalCost();
			});
		});
	}
}

function plans() {

	const planTables = $('.checkout_table');

	if (planTables.length) {
		planTables.each(function(index, el){
			let planTable = $(el),
				planColumns = planTable.attr('data-checkouttablecolumns'),
				planRows = planTable.find('table > tbody tr'),
				planInputs = planTable.find('tr input'),
				planMonthlyCosts = planTable.find('.plan-monthly-costs [data-monthly-cost]'),
				table = {};

			planRows.each(function(index, el){
				let row = $(el);
				let cols = row.find('> td');

				for (let i = 0; i < parseInt(planColumns); i++) {
					let  currentColItem = $(cols[i]);

					// needs to be an array
					if (!(table[i] && Array.isArray(table[i]))) {
						table[i] = [];
					}

					if (currentColItem.attr('data-cost') && currentColItem.attr('data-featurename') !== 'Call Reporting & Recording') {
						table[i].push({
							cost: parseFloat(currentColItem.attr('data-cost')),
							perUser: row.hasClass('per-user'),
							type: currentColItem.hasClass('one-time') ? 'one' : currentColItem.hasClass('monthly') ? 'month' : ''
						});
					}
				}
			});

			// console.log(table);

			planInputs.keyup(function () {
				let _input = $(this);
				let inputIndex = _input.closest('td').index() - 1;
				let tr = _input.closest('tr');
				let user = $(`[data-column="Column ${inputIndex + 1}"][data-featurename="Users"] input`),
					userValue = user.val();

				planData[inputIndex] = [];

				// console.log(table[inputIndex]);
				// console.log('-----------------------');

				let colData = table[inputIndex];

				planData[inputIndex].push({
					totalSetup: 0,
					monthlySetup: parseFloat($(planMonthlyCosts[inputIndex]).attr('data-monthly-cost')) * userValue
				});

				for (let key in colData) {
					// skip loop if the property is from prototype
					if (!colData.hasOwnProperty(key)) continue;

					// got the col
					// properties cost perUser
					let obj = colData[key],
						pushData = {
							totalStep: 0,
							monthlySetup: 0
						};

					if (obj.type === 'one') {
						pushData.monthlySetup = 0;
						pushData.totalSetup = obj.cost * parseInt(userValue);
					} else {
						pushData.totalSetup = 0;
						pushData.monthlySetup = obj.cost * parseInt(userValue);
					}

					planData[inputIndex].push(pushData);
				}

				let call = $(`[data-column="Column ${inputIndex + 1}"][data-featurename="Call Reporting & Recording"] input`),
					callValue = call.val(),
					callCost = call.closest('td').attr('data-cost');

				if (parseInt(callValue) > 0 && parseFloat(callCost) > 0) {
					planData[inputIndex].push({
						totalSetup: 0,
						monthlySetup: parseFloat(callCost) * parseInt(callValue)
					});
				}

				estimateTotalCost();
			});

		});
	}

}

function calculateAmounts(data) {
	let costs = {
		setup: 0,
		monthly: 0
	};

	for (let key in data) {
		// skip loop if the property is from prototype
		if (!data.hasOwnProperty(key)) continue;

		let obj = data[key];

		obj.forEach(function (el) {
			costs.setup += parseFloat(el.totalSetup);
			costs.monthly += parseFloat(el.monthlySetup);
		});
	}

	return costs;
}

function totalUpFees(elements, name) {
	let totalCost = 0;

	elements.each(function(){
		let _this = $(this);
		let val = parseFloat(_this.attr('data-' + name));
		totalCost += val;
	});

	return totalCost;
}

function estimateTotalCost() {
	// .checkoutTotal

	const checkoutTotal = $('.checkout_total');
	const checkoutTotalSetup = checkoutTotal.find('.checkout_total-setup td');
	const checkoutTotalPlans = checkoutTotal.find('.checkout_total-plans td');
	const checkoutTotalHandset = checkoutTotal.find('.checkout_total-handsets td');
	const checkoutTotalTotal = checkoutTotal.find('.checkout_total-total td');

	let allCostFee = 0;
	let allMonthlyFee = 0;

	let optionalCosts = calculateAmounts(optionalData);
	let cardCosts = calculateAmounts(cardsData);
	let planCosts = calculateAmounts(planData);

	// setup
	checkoutTotalSetup.first().html('$' + getTextFromValue(optionalCosts.setup)).attr('data-costfee', optionalCosts.setup);
	checkoutTotalSetup.last().html('$' + getTextFromValue(optionalCosts.monthly)).attr('data-monthlyfee', optionalCosts.monthly);

	// handsets
	checkoutTotalHandset.first().html('$' + getTextFromValue(cardCosts.setup)).attr('data-costfee', cardCosts.setup);
	checkoutTotalHandset.last().html('$' + getTextFromValue(cardCosts.monthly)).attr('data-monthlyfee', cardCosts.monthly);

	// plans
	checkoutTotalPlans.first().html('$' + getTextFromValue(planCosts.setup)).attr('data-costfee', planCosts.setup);
	checkoutTotalPlans.last().html('$' + getTextFromValue(planCosts.monthly)).attr('data-monthlyfee', planCosts.monthly);

	// sum up all
	allCostFee = totalUpFees(checkoutTotal.find('[data-costfee]'), 'costfee');
	allMonthlyFee = totalUpFees(checkoutTotal.find('[data-monthlyfee]'), 'monthlyfee');

	checkoutTotalTotal.first().html('$' + getTextFromValue(allCostFee));
	checkoutTotalTotal.last().html('$' + getTextFromValue(allMonthlyFee));

}

export default function comparisonDirective(context = document.body) {
	const $context = $(context);

	plans();
	optionalNumbers();
	extraProducts();
	estimateTotalCost();
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/comparison.js